import { useDispatch, useSelector } from "react-redux";
import { Modal } from "../Modal";
import {
  editPickupModalOpenSelector,
  pickupEditOptionsModalOpenSelector,
} from "../../../reducers/ownApp/selectors";
import {
  editPickupAreasSelector,
  editModalPickupAreasSelector,
  routeInEditSelector,
  pickupModalGridConfigSelector,
} from "../../../reducers/matrixProfile/selectors";
import {
  applyPickupEdit,
  cancelPickupEdit,
  setModalPickupEditAction,
} from "../../../reducers/matrixProfile/thunkActions";
import { EditPickupContent } from "./EditPickupContent";
import { EditPickupActions } from "./EditPickupActions";

export const EditPickupModal = () => {
  const routeEdit = useSelector(routeInEditSelector);
  const modalOpen = useSelector(editPickupModalOpenSelector);
  const editOptionsModalOpen = useSelector(pickupEditOptionsModalOpenSelector);
  const editModalPickupAreas = useSelector(editModalPickupAreasSelector);
  const editPickupAreas = useSelector(editPickupAreasSelector);
  const pickupModalGridConfig = useSelector(pickupModalGridConfigSelector);
  const dispatch = useDispatch();

  const onClose = () => dispatch(cancelPickupEdit());

  const onSave = () => dispatch(applyPickupEdit());

  const onEdit = (key) => dispatch(setModalPickupEditAction({ key }));

  if (!routeEdit || !pickupModalGridConfig || editOptionsModalOpen) return null;

  return (
    <Modal
      open={modalOpen}
      title={`Pickup: Route ${routeEdit.routeCode}`}
      minWidth={500}
      onClose={onClose}
      content={
        <EditPickupContent
          routeEdit={routeEdit}
          pickupModalGridConfig={pickupModalGridConfig}
          onEdit={onEdit}
        />
      }
      actions={
        <EditPickupActions
          disabled={editModalPickupAreas === editPickupAreas}
          onCancel={onClose}
          onSave={onSave}
        />
      }
    />
  );
};
